import { useTranslation } from "react-i18next";
import { HiMagnifyingGlass } from "react-icons/hi2";

import FeaturedText from "@/components/molecules/FeaturedText";

const NoSearchResults = () => {
  const { t } = useTranslation();

  return (
    <FeaturedText
      heading={t("search.noResults.title")}
      body={t("search.noResults.text")}
      size={"lg"}
      featuredIcon={{
        icon: HiMagnifyingGlass,
        color: "primary",
        size: "xl",
      }}
    />
  );
};

export default NoSearchResults;
